import moment from 'moment-timezone';

export class EnterpriseDashboardBudgetTimeframeRow {
	public date: Date;
	public referenceDate: Date;
	public serviceTypeId: string;
	public referenceBudgetCost: number;
	public actualCost: number;
	public varianceAmount: number;
	public currentBudgetCost: number;

	public actualUsage: number;
	public actualIsUsageEstimated: boolean;
	public actualIsTaxRateEstimated: boolean;
	public actualIsDeliveryRateEstimated: boolean;
	public referenceUsage: number;
	public varianceUsageAmount: number;
	public varianceUsagePercent: number;
	public currentBudgetUsage: number;
	public currentBudgetUsagePercent: number;

	public referenceSupplyCost: number;
	public actualSupplyCost: number;
	public actualIsSupplyCostEstimated: boolean;
	public varianceSupplyCostAmount: number;
	public varianceSupplyCostPercent: number;
	public currentBudgetSupplyCost: number;
	public currentBudgetSupplyCostPercent: number;

	public referenceBudgetDeliveryAndTaxCost: number;
	public actualDeliveryAndTaxCost: number;
	public varianceDeliveryAndTaxCostAmount: number;
	public varianceDeliveryAndTaxCostPercent: number;
	public currentBudgetDeliveryAndTaxCost: number;
	public currentBudgetDeliveryAndTaxCostPercent: number;
	public isDeliveryAndTaxIncomplete: boolean;

	constructor(enterpriseDashboardBudgetTimeframeRow?: EnterpriseDashboardBudgetTimeframeRow) {
		Object.assign(this, enterpriseDashboardBudgetTimeframeRow);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;
		this.referenceDate = this.referenceDate ? new Date(moment(this.referenceDate).format('MMM DD, YYYY 00:00:00 a')) : this.referenceDate;
	}
}
